import * as React from 'react';
import { Form, Button } from 'react-bootstrap';

interface EntityHierRelationshipImportProps{
    relImportAction: string;
    selectedRelationship: any | null;
    relationships: any[];
    hierarchies: any[];
    entities: any[];
    handleRelAndHierarchySave: (rel: any, hier: any) => void;
    toggleShowRelImportModal: () => void;
}

interface EntityHierRelationshipImportState {
  selectedRelationship: any | null;
}


class EntityHierRelationshipImport extends React.Component<EntityHierRelationshipImportProps, EntityHierRelationshipImportState> {
  constructor(props: EntityHierRelationshipImportProps) {
    super(props);
    this.state = {
      selectedRelationship: this.props.selectedRelationship || {},
    };
  }

  handleRelationshipChange = (event: any) => {
      const selectedRelationship = this.props.relationships.find((relationship: any) => relationship['@id'] === event.target.value);
      const tbl_entities_map = this.props.entities.reduce((acc, current) => {
        const physicalId = current.field[0].FLD_PHYSICAL_ID.split('-')[0];
        if (!acc[physicalId]) {
          acc[physicalId] = [];
        }
        acc[physicalId].push({
          name: current.name,
          label: current.label
        });
        return acc;
      }, {});

      let fromObjectFound = tbl_entities_map[selectedRelationship.fromHubObject].find((item:any) => item.name === selectedRelationship.fromObject);
      if (!fromObjectFound) {
        const firstValue = tbl_entities_map[selectedRelationship.fromHubObject][0];
        selectedRelationship.fromObject = firstValue.name;
      }

      let toObjectFound = tbl_entities_map[selectedRelationship.toHubObject].find((item:any) => item.name === selectedRelationship.toObject);
      if (!toObjectFound) {
        const firstValue = tbl_entities_map[selectedRelationship.toHubObject][0];
        selectedRelationship.toObject = firstValue.name;
      }

      this.setState({
        selectedRelationship,
      });
  };
    
  handleInportRelAndHierarchySubmit = ()=>{
      const selectedRelationship = this.state.selectedRelationship;
      
      if (selectedRelationship && Object.keys(selectedRelationship).length > 0 ) {
        const selHier = this.props.hierarchies.filter((h:any)=> {return h['@id'] === selectedRelationship['@parentId']})[0];
        this.props.handleRelAndHierarchySave(selectedRelationship, selHier);
        this.props.toggleShowRelImportModal();
      }
  }


  render() {
    const { relationships, entities, hierarchies } = this.props;
    const { selectedRelationship } = this.state;
      
    const tbl_entities_map = entities.reduce((acc, current) => {
      const physicalId = current.field[0].FLD_PHYSICAL_ID.split('-')[0];
      if (!acc[physicalId]) {
        acc[physicalId] = [];
      }
      acc[physicalId].push({
        name: current.name,
        label: current.label
      });
      return acc;
    }, {});
      
    return (
      <div>
        <Form>
          {this.props.relImportAction === 'IMPORT' &&
          <Form.Group controlId="relationshipName" className="custom-select mb-3">
            <Form.Label>Relationship Name:</Form.Label>
            <Form.Control as="select" value={selectedRelationship["@id"]} onChange={this.handleRelationshipChange}>
              <option value="">Select Relationship</option>
              {relationships.map((relationship: any) => (
                <option key={relationship["@id"]} value={relationship["@id"]}>
                  {relationship.name} - {relationship.label}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          }
          {(selectedRelationship && Object.keys(selectedRelationship).length > 0 ) &&
          <>
          <Form.Group controlId="relationshipNameE" className="mb-3">
              <Form.Label>Name:</Form.Label>
              <Form.Control 
                type="text" 
                value={selectedRelationship.name} 
                onChange={(e) => this.setState({ 
                  selectedRelationship: { ...this.state.selectedRelationship, name: e.target.value } 
                })} 
              />
          </Form.Group>
          <Form.Group controlId="relationshipLabel" className="mb-3">
              <Form.Label>Display name:</Form.Label>
              <Form.Control 
                type="text" 
                value={selectedRelationship.label} 
                onChange={(e) => this.setState({ 
                  selectedRelationship: { ...this.state.selectedRelationship, label: e.target.value } 
                })} 
              />
          </Form.Group>
          <Form.Group controlId="direction" className="custom-select mb-3">
            <Form.Label>Direction of relationship:</Form.Label>
            <Form.Control as="select" value={selectedRelationship.relDirection} onChange={(e) => this.setState({ 
                  selectedRelationship: { ...this.state.selectedRelationship, relDirection: e.target.value } 
                })} >
              
                <option key={'Directed'} value={'Directed'}>{'Directed'}</option>
                <option key={'Bidirectional'} value={'Bidirectional'}>{'Bidirectional'}</option>
                <option key={'Undirected'} value={'Undirected'}>{'Undirected'}</option>
            
            </Form.Control>
          </Form.Group>
          <Form.Group controlId="fromEntity" className="custom-select mb-3">
            <Form.Label>From Entity:</Form.Label>
            <Form.Control as="select" value={selectedRelationship.fromObject} onChange={(e) => this.setState({ 
                  selectedRelationship: { ...this.state.selectedRelationship, fromObject: e.target.value } 
                })} >
              {tbl_entities_map[selectedRelationship.fromHubObject].map((e: any) => (
                <option key={e.name} value={e.name}>
                  {e.label}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          <Form.Group controlId="toEntity" className="custom-select mb-3">
            <Form.Label>To Entity:</Form.Label>
            <Form.Control as="select" value={selectedRelationship.toObject} onChange={(e) => this.setState({ 
                  selectedRelationship: { ...this.state.selectedRelationship, toObject: e.target.value } 
                })} >
              {tbl_entities_map[selectedRelationship.toHubObject].map((e: any) => (
                <option key={e.name} value={e.name}>
                  {e.label}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          <Form.Group controlId="hierarchy" className="custom-select mb-3">
            <Form.Label>Hierarchy:</Form.Label>
            <Form.Control as="select" value={selectedRelationship['@parentId']} onChange={(e) => this.setState({ 
                  selectedRelationship: { ...this.state.selectedRelationship, "@parentId": e.target.value } 
                })} >
              {hierarchies.map((e: any) => (
                <option key={e['@id']} value={e['@id']}>
                  {e.label}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          
          </>
           }
        </Form>
        <div className="d-flex justify-content-center">
            <div>
                <Button variant="primary" type="submit" onClick={this.handleInportRelAndHierarchySubmit} style={{marginLeft:'10px'}} size="sm">
                    Submit
                </Button>
            </div>
        </div>
      </div>
    )
  }
}

export default EntityHierRelationshipImport;